import cloneDeep from 'lodash-es/cloneDeep.js';
import set from 'lodash-es/set.js';
/**
 * Check whether a value is nullish (null or undefined).
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Nullish_coalescing
 */
export function isNullish(value) {
    return value === null || value === undefined;
}
/**
 * Create a deferred promise, which can be resolved externally.
 * @see https://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
 */
export function deferredPromise() {
    let res = () => { };
    let rej = () => { };
    const promise = new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
/**
 * Normalize errors from Cohesion products.
 */
export function normalizeError(err) {
    if (!err) {
        return null;
    }
    const result = {
        message: 'Unknown error',
    };
    if (typeof err.error === 'object') {
        result.message = err.error.error;
        if (err.error.traceId) {
            result.traceId = err.error.traceId;
        }
    }
    if (typeof err.error === 'string') {
        result.message = err.error;
        if ('meta' in err) {
            result.timeout = err.meta?.timeout;
        }
    }
    return result;
}
/**
 * Check whether a value is an object.
 */
export function isObject(obj) {
    return obj && typeof obj === 'object';
}
/**
 * Find all functions in an object.
 */
export const findFunctions = (obj, path, result) => {
    result = result || {};
    if (!isObject(obj)) {
        return result;
    }
    for (const key in obj) {
        const value = obj[key];
        const newPath = path ? `${path}.${key}` : key;
        if (value instanceof Function) {
            result[newPath] = value;
        }
        else if (isObject(value)) {
            findFunctions(value, newPath, result);
        }
    }
    return result;
};
/**
 * Stringify an object, replacing functions with placeholders.
 */
export function stringifyObject(obj) {
    let fnMap = {};
    // TODO: Use `structuredClone` as soon as Next.js supports it.
    let objCopy = cloneDeep(obj);
    // Replace functions with placeholders.
    if (isObject(objCopy)) {
        fnMap = findFunctions(objCopy);
        for (const path in fnMap) {
            set(objCopy, path, `%%%${path}%%%`);
        }
    }
    // Stringify the object.
    let result = JSON.stringify(objCopy);
    // Replace placeholders with function strings.
    for (const path in fnMap) {
        const fnString = fnMap[path].toString();
        result = result.replace(`"%%%${path}%%%"`, fnString);
    }
    return result;
}
